import { get } from "@/services/axiosUitils";

export type PtsTaskListingParams = {
  page?: number;
  page_size?: number;
  project?: string;
  assignees?: string;
  sprint?: string;
  status?: string;
  taskname?: string;
};

export type PtsTaskListingItem = {
  id: string;
  taskname: string;
  project: string;
  parent_task: string | null;
  status: string | null;
  sprint: string | null;
  taskcategory: string | null;
  taskestimatedhours: string;
  work_type: string | null;
  actualhours: string;
  variance: string;
  servicedesk_uid: string | null;
  created_by: string;
  updated_by: string;
  created_on: string;
  updated_on: string;
  subtask: PtsTaskListingItem[];
};

export type PtsTaskListingResponse = {
  count: number;
  page: number;
  page_size: number;
  results: PtsTaskListingItem[];
  links?: {
    next: string | null;
    previous: string | null;
  };
};

class PtsTaskListingService {
  getTaskListing = async (
    params: PtsTaskListingParams = {}
  ): Promise<PtsTaskListingResponse> => {
    return await get<PtsTaskListingResponse>("/pts_app/pts-task-listing/", {
      params,
    });
  };
}

const instance = new PtsTaskListingService();
export default instance;
